<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <app-outside-survey-photo-form *ngFor="let address of survey.building.addresses; let j = index" [survey]="survey"
      [camera]="camera" [cameraLayer]="cameraLayer" [address]="survey.building.addresses[j]" [index]="j + 1"
      [isAuthCanWrite]="isAuthCanWrite" [formErrors]="formErrors"></app-outside-survey-photo-form>
  </div>
  <div class="open-all-btn-wrapper">
    <div *ngIf="showOpenButton$ | async; else collapseBtn" class="open-all-btn" (click)="openAllFrames()">
      <mat-icon>launch</mat-icon>
    </div>
    <ng-template #collapseBtn>
      <div class="open-all-btn" (click)="closeAllFrames()">
        <mat-icon class="material-icons-outlined">disabled_by_default</mat-icon>
      </div>
    </ng-template>
  </div>
</div>